import React from "react";
import { motion } from "framer-motion";

export function RouteTransition({ transitionKey, isDark }) {
  if (!transitionKey) return null;
  return <div key={transitionKey} className={`route-transition ${isDark ? "theme-dark" : "theme-light"}`} aria-hidden="true" />;
}

export function SessionBootstrap({ isDark }) {
  return (
    <main className={`session-bootstrap ${isDark ? "theme-dark" : "theme-light"}`} aria-label="正在恢复会话">
      <motion.div className="session-bootstrap-brand"
        initial={{ opacity: 0, y: 10, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.42, ease: [0.16, 1, 0.3, 1] }}>
        <div className="session-bootstrap-mark" aria-hidden="true">LN</div>
        <span>LumaNova AI</span>
        <div className="session-bootstrap-progress" aria-hidden="true"><i /></div>
      </motion.div>
    </main>
  );
}
